import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ServiceDetailPageContainer } from './ServiceDetailPage';
import { FaPaperPlane } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

const ServiceImage = styled.img`
  max-width: 200px;
  height: auto;
  border-radius: 0;
  margin: 0.5rem 0 1rem 2rem;
  box-shadow: none;
  float: right;

  @media (max-width: 768px) {
    float: none;
    margin: 1rem auto;
    max-width: 80%;
    display: block;
  }
`;

const ContactSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: white;
  position: relative;
  overflow: hidden;
  margin-top: 8rem;
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), transparent);
    transform: skewX(-20deg) translateX(30%);
    transform-origin: top right;
    pointer-events: none;
    z-index: 0;
  }
`;

const ContactContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
  width: 100%;
`;

export const ContactTitle = styled.h2`
  color: #fff !important;
  margin-top: 0 !important;
`;

const ContactForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ContactInput = styled.input`
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled.button`
  background: #00B4DB;
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 180, 219, 0.2);

  &:hover {
    background: #007bff;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 180, 219, 0.3);
  }

  svg {
    margin: 0;
  }
`;

function TrademarkServices() {
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Only allow numbers and limit to exactly 11 digits
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setFormData({
          ...formData,
          [name]: numbersOnly
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    try {
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        time: new Date().toLocaleString('tr-TR')
      };

      await emailjs.send(
        'service_771tgg7',
        'template_w676du8',
        templateParams,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setFormData({ name: '', phone: '' });
    } catch (error) {
      alert('Bir hata oluştu');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ServiceDetailPageContainer>
      <h1>Marka Tescil Hizmetleri</h1>
      <p>Markanızı yasal olarak koruma altına alıyor, tescil süreçlerinizi profesyonel bir şekilde yönetiyoruz. Uzman ekibimiz, markanızın değerini korumak ve geliştirmek için gerekli tüm yasal süreçleri sizin için yönetiyor.</p>
      
      <ServiceImage src="/media/demirer-ajans-4.png" alt="Marka Tescil Hizmetleri Görseli 1" />

      <h2>Neden Marka Tescili Önemlidir?</h2>
      <p>Marka tescili, işletmenizin en değerli varlıklarından biridir. Tescilli bir marka, rakiplerinizin sizin markanızı kullanmasını engeller, yasal haklarınızı korur ve markanızın değerini artırır. Ayrıca, tescilli markanız, işletmenizin güvenilirliğini ve profesyonelliğini vurgular.</p>

      <ServiceImage src="/media/demirer-ajans-5.png" alt="Marka Tescil Hizmetleri Görseli 2" />

      <h3>Marka Tescil Hizmetlerimiz Neleri Kapsar?</h3>
      <ul>
        <li><b>Marka Araştırması:</b> Detaylı marka araştırması ile benzer markaların varlığını kontrol ediyoruz.</li>
        <li><b>Başvuru Hazırlığı:</b> Tüm gerekli belgeleri hazırlayıp, başvuru sürecini başlatıyoruz.</li>
        <li><b>Tescil Süreci Yönetimi:</b> Başvuru sürecini takip edip, gerekli düzeltmeleri ve itirazları yönetiyoruz.</li>
        <li><b>Uluslararası Marka Tescili:</b> Yurtdışında marka tescili için gerekli süreçleri yönetiyoruz.</li>
        <li><b>Marka Yenileme:</b> Marka tescillerinin yenilenmesi için gerekli işlemleri yapıyoruz.</li>
        <li><b>Marka İzleme:</b> Markanızın izinsiz kullanımını takip ediyor ve gerekli yasal işlemleri başlatıyoruz.</li>
        <li><b>Marka Lisanslama:</b> Marka lisanslama süreçlerini yönetiyor ve gerekli sözleşmeleri hazırlıyoruz.</li>
        <li><b>Marka Değerleme:</b> Markanızın değerini belirlemek için profesyonel değerleme hizmetleri sunuyoruz.</li>
      </ul>

      <ServiceImage src="/media/demirer-ajans-6.png" alt="Marka Tescil Hizmetleri Görseli 3" />

      <h2>Markanızı Güvence Altına Alın</h2>
      <p>Marka tescil süreci karmaşık ve zaman alıcı olabilir. Uzman ekibimiz, bu süreci sizin için yöneterek, markanızın yasal koruma altına alınmasını sağlıyor. Her aşamada sizi bilgilendiriyor, gerekli düzenlemeleri yapıyor ve sürecin sorunsuz ilerlemesini sağlıyoruz.</p>
      <p>Markanızın değerini korumak ve geliştirmek için profesyonel marka tescil hizmetlerimizden yararlanın. Yasal haklarınızı güvence altına alarak, işletmenizin geleceğini koruyun.</p>

      <h2>Marka Tescil Hizmetlerimiz</h2>
      <p>Marka tescil hizmetlerimiz, işletmenizin fikri mülkiyet haklarını korumak için tasarlanmıştır. Uzman ekibimiz, marka tescil sürecini baştan sona yönetir ve markanızın yasal koruma altına alınmasını sağlar.</p>
      <p>Profesyonel danışmanlık ve hızlı işlem süreçleriyle, markanızın değerini koruyor ve büyümesini destekliyoruz. İşletmenizin fikri mülkiyet haklarını güvence altına almak için bize güvenebilirsiniz.</p>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Sizi Arayalım</ContactTitle>
          <ContactForm onSubmit={handleSubmit}>
            <ContactInput 
              type="text" 
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleInputChange}
              required 
            />
            <ContactInput 
              type="tel" 
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required 
            />
            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPaperPlane />
            </SubmitButton>
          </ContactForm>
        </ContactContent>
      </ContactSection>
    </ServiceDetailPageContainer>
  );
}

export default TrademarkServices; 